import firebase from 'firebase'
import { firebaseAction } from 'vuexfire'

const state = {
  all: []
}
const getters = {
  all: state => state.all
}
const actions = {
  bind: firebaseAction(({ bindFirebaseRef, rootGetters }, company) => {
    if (company && company.id) {
      bindFirebaseRef('all', firebase.firestore().collection('companies').doc(company.id).collection('orders').where('deleted', '==', false))
    }
  }),
  add ({ rootGetters }, product, file) {
    const company = rootGetters['companies/mine']
    const profile = rootGetters['profiles/mine']
    if (company && company.id) {
      return firebase.firestore().collection('companies').doc(company.id).collection('orders').add(product)
    }
  }
}
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/orders.js